import type { AccordionEventKey } from "react-bootstrap/esm/AccordionContext";

import classNames from "classnames";
import { useState } from "react";
import { Accordion, Nav } from "react-bootstrap";
import { ChevronDown, Globe } from "react-bootstrap-icons";

import { useOffcanvas } from "@/components/context/OffcanvasContext";
import useLanguageSwitcher from "@/hooks/useLanguageSwitcher";
import changeLanguageEvent from "@/services/analyticsEvents/changeLanguageEvent";

import styles from "./MobileLanguageSwitcher.module.scss";

interface IMobileLanguageSwitcherProps {
  className?: string;
}

function MobileLanguageSwitcher({ className }: IMobileLanguageSwitcherProps) {
  const { changeLanguage, currentLanguage, languages } = useLanguageSwitcher();
  const [activeKey, setActiveKey] = useState<AccordionEventKey>(null);
  const offcanvas = useOffcanvas();

  return (
    <Accordion
      activeKey={activeKey}
      onSelect={(eventKey) => setActiveKey(eventKey)}
      className={classNames(styles.accordion, className)}
    >
      <Accordion.Item eventKey="0" className={styles.accordionItem}>
        <Accordion.Header>
          <span className="w-100 d-inline-flex align-items-center justify-content-between">
            <span className="text-uppercase d-inline-flex align-items-center gap-3">
              <Globe className="fs-7" />
              <span className="fs-8">{currentLanguage}</span>
            </span>
            <ChevronDown className="chevron" />
          </span>
        </Accordion.Header>
        <Accordion.Body className={styles.accordionBody}>
          <Nav
            variant="pills"
            className={classNames("flex-column", styles.nav)}
          >
            {languages.map((item) => (
              <Nav.Link
                key={item.value}
                onClick={() => {
                  const language = currentLanguage;
                  const newLanguage = item.value;

                  changeLanguage(newLanguage);
                  changeLanguageEvent({
                    language,
                    newLanguage,
                  });

                  setActiveKey(null);
                  offcanvas.close();
                }}
                active={currentLanguage === item.value}
                className={styles.link}
              >
                {item.label}
              </Nav.Link>
            ))}
          </Nav>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default MobileLanguageSwitcher;
